module.exports = __webpack_public_path__ + "img/FCST-ability-04.42781ef4.png";